import { DateInput as MantineDateInput, type DateInputProps } from '@mantine/dates'
import dayjs from 'dayjs'
import { useState } from 'react'
import { pickerOpeningDate } from '@/utils/dateInput'

/**
 * Mantine's DateInput, opening on the right month every time (PD-1901): the
 * value's month, else today within min/max. Mantine keeps the last browsed
 * month across close and reopen, so an empty field would otherwise reopen on
 * whatever month was viewed last. Opening never touches the value.
 */
export function DateInput(props: DateInputProps) {
  const openingDate = () =>
    pickerOpeningDate(props.value ?? props.defaultDate, props.minDate, props.maxDate)
  const [shownDate, setShownDate] = useState<string>()

  return (
    <MantineDateInput
      {...props}
      date={shownDate ?? openingDate()}
      // A string, not the Date Mantine re-syncs from `value`: an equal string is a no-op, a new Date re-renders forever.
      onDateChange={(next) => setShownDate(dayjs(next).format('YYYY-MM-DD'))}
      popoverProps={{
        ...props.popoverProps,
        onOpen: () => {
          setShownDate(openingDate())
          props.popoverProps?.onOpen?.()
        },
      }}
    />
  )
}
